const CreditCardFormLogic = () => {
    const RADIO_INPUT_FIELD = '.teaser-input-radio';
    const SELECT_INPUT_FIELD = '.teaser-input-select';
    const SELECT_INPUT = '#refProduct';
    const HIDDEN_CLASS = 'teaser-input-select--hidden';
    const radioInputField = document.querySelector(RADIO_INPUT_FIELD);
    const selectInputField = document.querySelector(SELECT_INPUT_FIELD);
    const selectInput = document.querySelector(SELECT_INPUT);

    if (!radioInputField || !selectInput || !selectInputField) {
        return false;
    }

    radioInputField.addEventListener('change', (e) => {
        if (e.target.value === 'true') {
            selectInputField.classList.remove(HIDDEN_CLASS);
        } else {
            selectInputField.classList.add(HIDDEN_CLASS);
            selectInput.value = '';
        }
    });
};

export default CreditCardFormLogic;
